<template>
	<div class="event" @click="open">
		<div class="icon" v-if="loading">
			<uiLoader />
		</div>
		<div class="icon" v-else>{{ icon }}</div>
		<div class="title">
			{{ title }}
			<span>{{ text }}</span>
		</div>
	</div>
</template>

<script>
import { API } from '@/config'
import { format } from 'date-fns'
import { getPetEvent, getPetDocument } from '@/utils/dicts'

export default {
	name: 'PetEvent',
	props: {
		event: Object,
	},
	data() {
		return {
			loading: false,
			loaded: null,
			editing: false,
			details: null,
		}
	},
	computed: {
		kind() {
			return this.event.kind
		},
		icon() {
			if (this.event.icon) return '' //this.event.icon
			return getPetEvent(this.kind).emoji
		},
		title() {
			if (this.event.kind === 'document') {
				return getPetDocument(this.event.title) ?? this.event.title
			}

			return [
				this.event.title || getPetEvent(this.event.kind).title || '–',
				this.event.date &&
					`в ${format(new Date(this.event.date), 'HH:mm')}`,
			]
				.filter(Boolean)
				.join(' ')
		},
		text() {
			return this.event.text
		},
	},
	methods: {
		open(e) {
			if (this.kind !== 'document') {
				return this.$emit('click', e)
			}

			this.openDocument()
		},
		async openDocument() {
			let id = this.event.details.document
			if (!id) return

			if (!this.loaded) {
				if (this.loading) return
				this.loading = true
				let { data } = await this.$http.get(API.DOCUMENTS.get + id)
				if (!data || data.err) {
					this.$notify(data.err)
					return (this.loading = false)
				}
				this.loaded = data
				this.loading = false
			}

			if ([this.loaded.kind, this.loaded.mode].includes('pdf')) {
				let url = this.loaded.files[0].url
				this.$events.$emit('pdfViewer', url)
			} else {
				let urls = this.loaded.files.map(f => f.url)
				this.$events.$emit('imageViewer', urls)
			}
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.event {
	padding: 10px 16px;
	border-radius: 20px;
	background: @grey;
	display: flex;
	align-items: center;
	cursor: pointer;
	margin-bottom: 10px;

	.icon {
		width: 32px;
		height: 32px;
		font-size: 26px;
		margin-right: 10px;
	}

	.title {
		font-size: 14px;
		font-weight: 500;

		span {
			opacity: 0.5;
			display: block;
			font-size: 12px;
		}
	}
}
</style>
